var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJeffreyjump2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 490.44 430.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #b3b3b3;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3px;\n      }\n\n      .cls-1, .cls-9 {\n        fill: #b3b3b3;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-2, .cls-4 {\n        stroke: #474748;\n      }\n\n      .cls-10 {\n        fill: #b7b7b7;\n      }\n\n      .cls-10, .cls-9, .cls-11, .cls-12 {\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        fill: #6d6d6d;\n        stroke: #6d6d6d;\n      }\n\n      .cls-11 {\n        fill: #eaeaea;\n      }\n\n      .cls-12 {\n        fill: #d7d7d7;\n      }\n\n      .cls-4 {\n        fill: #474748;\n      }\n\n      .cls-5 {\n        fill: #b6b6b6;\n        stroke: #b6b6b6;\n      }\n\n      .cls-6 {\n        fill: #878787;\n        stroke: #878787;\n      }\n\n      .cls-7 {\n        fill: #e9e9e9;\n        stroke: #e9e9e9;\n      }\n\n      .cls-8 {\n        fill: #a7a7a7;\n        stroke: #a7a7a7;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Colour_mirror",
    "data-name": "Colour mirror"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M316.17,238.38l-9.2,4.3-2.4-3,2.3-24.2-30.8-18.2-30.9,6.2-30.9-6.2-30.8,18.2,2.3,24.2-2.4,3-9.2-4.3-5.2,5.1v9.2l14.5,23,5.2,3.6,6.9-1.5s11.1,26.6,20.2,34.5,15.7,12.6,15.7,12.6l13.8,1.4h0l13.8-1.4s6.5-4.7,15.7-12.6,20.2-34.5,20.2-34.5l6.9,1.5,5.2-3.6,14.5-23v-9.2l-5.2-5.1h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M175.37,250.78s-.8,1.1,2,5.7c2,3.3,3.9,8.5,6.2,10,0,0-.7-11.7-2.1-13.5s-6.2-2.2-6.2-2.2h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M204.27,242.28l-5.3,2.5s.9,4.5,4.1,5.7,10.3,1.3,10.3,1.3c0,0,11.4-.2,12.6-.9,2.6-1.7,2.6-7.9,2.6-7.9l-13.8-2.4-10.5,1.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "213.77 240.58 211.97 246.08 215.17 250.78 224.17 249.98 225.37 244.58 221.87 241.28 213.77 240.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M245.17,276.38s-5-1.8-6.6-1.3c-3.2,1-4,2.7-4,2.7,0,0,7.9,2.9,10.6,2.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "220.27 294.08 231.57 304.08 245.17 306.28 245.17 291.68 220.27 294.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "230.77 303.18 247.17 298.48 246.87 307.18 230.77 303.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "229.87 293.18 245.67 295.98 245.17 290.58 229.87 293.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "27.27 237.88 26.27 122.08 18.67 90.48 6.77 52.18 1.57 37.88 1.07 22.78 9.17 26.38 12.27 44.48 25.47 61.28 30.47 63.18 28.37 37.58 31.57 8.98 36.57 5.78 41.37 13.48 43.37 34.28 47.17 55.08 50.77 54.18 47.67 28.18 47.77 8.98 48.27 2.18 53.27 1.48 57.67 7.18 61.67 25.38 65.37 42.08 64.77 26.38 72.37 2.68 76.37 2.88 79.07 8.18 76.97 29.48 81.67 67.68 87.27 73.38 99.87 63.08 109.07 53.48 115.67 53.28 120.67 59.48 109.07 71.48 106.57 78.08 88.97 102.88 69.27 116.38 66.47 125.08 73.97 175.28 81.27 198.88 82.87 217.28 27.27 237.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M40.57,81.58s10.5,2.2,16.3,10.2c0,0,9.8-14.7,11.6-15.7,0,0,.1-1.9-4.2-.6s-6.2,3.4-9,3.7-8.2-1.6-11.1-1-3.6,3.5-3.6,3.5c0,0,0-.1,0-.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "94.17 346.48 111.97 334.88 128.17 319.08 134.67 303.88 135.37 291.68 110.17 259.78 80.27 217.28 33.97 224.78 27.27 237.88 42.57 254.18 94.17 346.48"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M315.07,250.78s.8,1.1-2,5.7c-2,3.3-3.9,8.5-6.2,10,0,0,.7-11.7,2.1-13.5s6.2-2.2,6.2-2.2h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M286.17,242.28l5.3,2.5s-.9,4.5-4.1,5.7-10.3,1.3-10.3,1.3c0,0-11.5-.2-12.6-.9-2.6-1.7-2.6-7.9-2.6-7.9l13.8-2.4,10.5,1.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "276.67 240.58 278.47 246.08 275.27 250.78 266.27 249.98 264.97 244.58 268.57 241.28 276.67 240.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M245.17,276.38s5-1.8,6.6-1.3c3.2,1,4,2.7,4,2.7,0,0-7.9,2.9-10.6,2.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "270.17 294.08 258.77 304.08 245.17 306.28 245.17 291.68 270.17 294.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "259.67 303.18 243.27 298.48 243.57 307.18 259.67 303.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "260.47 293.18 244.77 295.98 245.17 290.58 260.47 293.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M274.47,337.28v-21.9s-8.1,6.2-12.6,9.8c-2.5,2-8.3,2.5-13,2.5v-.3s-1.5.1-3.6.2c-2.1,0-3.6-.2-3.6-.2v.3c-4.8,0-10.6-.5-13-2.5-4.5-3.7-12.6-9.8-12.6-9.8v21.9h-8.2s10.8,20,22.8,23.8c2.7.9,5.5,1.5,8.2,1.9v1s2.6,0,6.4-.3c3.8.3,6.5.3,6.5.3v-1c2.6-.4,5.4-1,8.1-1.9,11.9-3.8,22.8-23.8,22.8-23.8h-8.2,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "463.17 237.88 464.17 122.08 471.67 90.48 483.67 52.18 488.87 37.88 489.37 22.78 481.27 26.38 478.17 44.48 464.97 61.28 459.97 63.18 462.07 37.58 458.87 8.98 453.87 5.78 449.07 13.48 447.07 34.28 443.17 55.08 439.67 54.18 442.67 28.18 442.67 8.98 442.07 2.18 437.17 1.48 432.77 7.18 428.77 25.38 425.07 42.08 425.67 26.38 417.97 2.68 414.07 2.88 411.37 8.18 413.47 29.48 408.77 67.68 403.07 73.38 390.47 63.08 381.37 53.48 374.77 53.28 369.77 59.48 381.37 71.48 383.87 78.08 401.47 102.88 421.17 116.38 423.97 125.08 416.47 175.28 409.07 198.88 407.57 217.28 463.17 237.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M449.87,81.58s-10.5,2.2-16.4,10.2c0,0-9.8-14.7-11.6-15.7,0,0-.1-1.9,4.2-.6s6.1,3.4,9,3.7,8.2-1.6,11.1-1,3.6,3.5,3.6,3.5l.1-.1h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "396.27 346.48 378.47 334.88 362.17 319.08 355.77 303.88 355.07 291.68 380.27 259.78 410.17 217.28 456.37 224.78 463.17 237.88 447.87 254.18 396.27 346.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "401.17 337.78 396.27 346.48 390.57 344.18 363.47 321.58 356.87 307.78 355.07 291.68 356.87 286.98 353.17 286.98 323.37 320.18 283.57 336.28 278.37 349.48 264.47 361.38 245.17 366.48 225.97 361.38 212.07 349.48 206.77 336.28 167.07 320.18 137.27 286.98 133.57 286.98 135.37 291.68 133.57 307.78 126.97 321.58 99.87 344.18 94.17 346.48 89.27 337.78 84.87 347.18 103.87 373.08 223.27 394.28 238.67 394.28 251.77 394.28 267.17 394.28 386.47 373.08 405.57 347.18 401.17 337.78"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Colour_Normal",
    "data-name": "Colour Normal"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M259.67,233.78s-7.1,10.8-7.8,13,1.3,28.3,1.3,28.3l1.1,3.4s9.2-2.6,9.2-6.2-5.9-25.4-5.9-25.4c0,0,6.2-9.6,14.4-7.1,3.7,1.1-3.1-8.7-3.1-8.7l-9.2,2.8h0v-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M287.97,215.38s-1.5,12.5-3.4,15.5-2.9,10.1-2.9,10.1l11.3,3.2s-3.5,10.5-5.1,12c-1.6,1.5-4.7,2.9-5.6,6.6s-2.9,25.3-5.3,31.7-13.8,27.6-13.8,27.6c0,0,20.4-22.5,23.3-28.1s15.1-33.8,15.2-40.1,2.5-22.2,2.5-22.2l-16.1-16.4h0l-.1.1h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "178.87 193.48 168.37 213.88 173.37 229.78 173.37 237.48 184.47 240.58 188.67 225.88 194.07 221.78 188.57 219.58 196.37 212.68 208.07 208.68 217.37 210.38 213.37 201.58 224.27 202.38 229.17 206.08 239.57 205.78 244.37 202.88 250.87 203.38 260.97 205.48 270.17 208.68 272.57 211.58 281.17 213.88 292.27 217.08 294.17 224.18 298.97 226.58 301.57 233.08 304.07 244.28 312.87 238.38 318.87 237.08 325.87 219.68 322.37 213.08 321.87 200.98 320.87 181.68 314.47 178.88 304.07 163.58 298.17 150.08 294.47 145.88 292.27 141.68 275.37 151.88 269.67 151.58 272.57 144.78 259.57 148.68 241.57 149.28 224.47 155.88 216.37 165.18 215.47 152.98 215.07 148.48 201.47 161.28 193.47 165.88 183.07 176.98 181.57 191.08 178.87 193.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M222.37,163.98s3.1-7.8,13.3-10.4c6.2-1.6,15.5-1.8,21,1.7,0,0-10.8,2.2-9.4,6.8s9.2,6,18.8,7.2,8.2,3,8.2,3c0,0-16.8,7.6-22.5,9.5s-27.2.6-25.8-5.6c1.8-8,8.3-9.4,5.4-12.1s-9.1,0-9.1,0h0l.1-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M189.07,178.48s-3.9,9.1-1.8,13.4,8.7,8.8,15.7,7,3.2-8.8,2.8-11.3-3.7-11.4-2.5-17.8c0,0-3.8,3.7-4.9,9.2-.9,4.3.2,9.5-3.6,8.1s-5.6-8.6-5.6-8.6h-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M176.47,206.08c4.2-1.9,7.3,3.4,8.5,3.7s6.6,1.6,6.2,2.7-5.4,1.6-7.3,3.4-1.3,3-2.3,4.1-8.1.9-9.3-2.8.8-9.4,4.3-11h0l-.1-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M263.07,187.58c-3-1,12-4.9,16.5-8.6s10.7-9.1,12.3-9.9c1.2-.7-1,9.9-7.4,13.5-7.8,4.4-16.6,6.6-21.4,5.1v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M277.97,194.48c-.9.2-1.4-.9-.8-1.5,4.3-4.1,8.9-8.3,15.4-12.4,1.4-.9,6.1-4.5,7.6-3.9s-.3,4.8,1.1,11.4-4.2,13-11.8,15.4c0,0,2.5-3.1.2-7-1.5-2.5-8.5-2.6-11.8-2h.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M307.97,209.08c1.9-1.9,6.9-11.5,8.3-10s.2,11.3-4.3,12.6-15.1,3.9-15.1,2.8,9.5-3.8,11.1-5.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M481.87,23.88c1.8,2,2.8,12.9,1.2,16.4s-9.8,20.5-10.4,24-14.6,35.7-16.1,47-17.4,9.4-17.4,9.4c0,0,14.6,2.8,14.3,6.2-.3,3.5,0,86.3-2.9,97.4-2.8,11.2,11.6,7.9,11.6,7.9,0,0,2.6-58.9.8-70.9-1.8-12-.3-41.2-.3-41.2l11.6-47.3,11.6-30.5.9-18.9-5,.4.1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M417.67,4.38s3.8,18.6,3.1,23-.8,24.2-.8,24.2l2.7-8.5v-17.9l-5-20.9h0v.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M432.27,53.38c1.3-4.4,6.8-21.2,6-30.4-.8-9.2,1.2-20.5,1.2-20.5l.5,24.5-3.8,26.9-3.9-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M456.37,6.18s-3.1,18.5,0,27.1l-3,29.5,5.3.7,1.5-28.3-3.7-29h-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M37.47,6.58c2.5,7.1,2.2,28.5,2.2,28.5,0,0,3.3,20,5.2,21.1s4.6,0,4.6,0l-6.9-24.6-2-22.9-3.1-2.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M52.17,1.98c3.1,4.9,5,22.7,5.4,25.8s4.9,25.1,6.9,25.7c2,.6,4.1-.3,4.1-.3l-8.2-25.5-2-20.3s-6.2-5.4-6.2-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M73.57,3.48c2.3,3.9,3.6,13,.9,23.7,0,0-.4,18.9,1.8,25.5,2.2,6.6,1.8,15.5,1.8,15.5l5.4,2.8-6.8-42.3,2.1-23.4-5.2-1.7h0s0-.1,0-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M110.67,54.08c4.6,2.4,4.5,5.1-1.4,13.3-5.8,8.2-14.9,23.8-19.4,27.1s-16.7,15.4-22.1,18.8-24.4,7.9-24.4,7.9c0,0,15.2-5.5,19-.3,2.3,3.2-.4,39.4,4,56.6s5.5,39.2,5.5,39.2l9.8-2.4-7.6-41.5-7.2-51.2,7.1-9.3,16.4-9.7,15.7-23.4,6.3-12.3,8.9-7.7-10.5-5.2h0l-.1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M5.27,24.08c3.6,7.6,6.1,22.1,6.1,22.1,0,0,9.2,19.2,12,18.9s5.7-.8,5.7-.8c-6.2-1.1-11.2-12.3-16.5-20.7l-4-18.5-3.3-1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M368.77,325.28c27-12.9,80.8-90.8,81.9-101l11,6.1v8.1l-15.1,15.7-31.4,57.4-19.6,32.9s-19.7-11.4-21.4-13.6-5.5-5.7-5.5-5.7h0l.1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M128.17,319.08c-5.2-15.7-56.3-102.5-56.3-102.5l9.8-2.4,2.4,9.3,49.5,68.8-2,16.9-3.3,9.9h-.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "89.67 338.48 85.47 347.38 94.97 346.58 89.67 338.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "400.57 338.38 396.97 347.48 407.17 347.48 400.57 338.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M381.17,338.38s-2.7,12.5-5.3,19.2-38.4,23.8-38.4,23.8l50.7-9.3,15.1-23.5s-10.8-2.8-12.4-3.5-9.6-6.7-9.6-6.7h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M101.37,342.98s5.9,13.1,10.2,18.7,18.6,22.7,18.6,22.7l-22.5-5.2-21.1-29.6s5.3-1.1,8.4-3,6.4-3.6,6.4-3.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M131.57,309.18s11.4,13,17.1,18.2,58.6,8.8,58.6,8.8l-40.7-16.6-29.1-33.4-3.3.2,1.3,5.8-3.8,17h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.07,320.98s11.4,32.4,11.4,39.3c0,0,.9-28.2-1.8-34.6s-9.6-4.7-9.6-4.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M329.97,314.08s-9.5,39.4-9.5,46.3c0,0-.9-28.2,1.8-34.6,2.7-6.4,7.7-11.7,7.7-11.7h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Lines_Mirror",
    "data-name": "Lines Mirror"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M245.17,327.48s4,0,11.1-1.6c12.3-2.9,27.2-22.8,34.3-35.4,7.5-13.2,14.9-46.2,14.9-46.2,0,0,6.2-7.6,12-5.6s4.7,12.6,3.7,14.7-11.2,22.8-17.3,26.1c-3.7,2.1-7.4-1.7-7.4-1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M316.07,249.78s.5-2.1-1.4-2.1-6.6,4.9-7.5,8.8c-.8,3.9.4,8-1,11.7-1.1,2.8-2.6,3.1-2.6,3.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M290.57,250.78s-4.9,2.2-11,1.8c-2.1-.1-6.4-1.2-9.8-1.2s-6.1.8-6.1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M294.07,233.08s-9.2-3-16.2-3.8c-4.2-.5-13.5-.6-14.3-.3s-4.2,3.8-3.2,3.9c1.1.2,12.8-1.6,18.5-1.6,6.7,0,15.2,1.8,15.2,1.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M292.87,244.28s-13.7-4.6-18.8-4.4-13.5,4-13.5,4c0,0,2.7-5.3,4.6-6.2s8.5-1.5,8.5-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M266.57,250.78s-1.8-1.4-2.1-3.3c-.5-3.8,4-5.7,5.4-5.9,5.4-.7,10.3,2.7,10.5,5.4s-4.3,5.3-4.3,5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.57,277.88s-1.1-.2-2,0-2.1,1.3-2.1,1.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M245.17,290.68c12.8-.5,27.2,3.4,27.2,3.4-5.6,3.8-9.3,8-14.6,10.5-5.2,1.4-12.6,1.7-12.6,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M261.47,292.18s-1.8,3.9-16.3,3.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M259.67,302.78s-5-3.4-14.5-3.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M274.97,338.08s-1.1-13.2,0-25.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.17,336.18s-6.1.6-7.6-1.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M245.17,327.48s-4,0-11.1-1.6c-12.3-2.9-27.2-22.8-34.3-35.4-7.4-13.2-14.9-46.2-14.9-46.2,0,0-6.2-7.6-12-5.6s-4.7,12.6-3.7,14.7,11.2,22.8,17.3,26.1c3.7,2.1,7.4-1.7,7.4-1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M174.27,249.78s-.5-2.1,1.4-2.1,6.6,4.9,7.5,8.8c.8,3.9-.4,8,1,11.7,1.1,2.8,2.6,3.1,2.6,3.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M199.87,250.78s4.9,2.2,11.1,1.8c2.1-.1,6.4-1.2,9.8-1.2s6.1.8,6.1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M196.37,233.08s9.2-3,16.2-3.8c4.2-.5,13.5-.6,14.3-.3s4.2,3.8,3.2,3.9c-1.1.2-12.8-1.6-18.5-1.6-6.7,0-15.2,1.8-15.2,1.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M197.57,244.28s13.7-4.6,18.8-4.4,13.4,4,13.4,4c0,0-2.7-5.3-4.6-6.2s-8.5-1.5-8.5-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M223.77,250.78s1.8-1.4,2.1-3.3c.5-3.8-4.1-5.7-5.4-5.9-5.4-.7-10.3,2.7-10.5,5.4s4.3,5.3,4.3,5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M236.77,277.88s1.1-.2,2,0,2.1,1.3,2.1,1.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M245.17,290.68c-12.8-.5-27.2,3.4-27.2,3.4,5.6,3.8,9.3,8,14.6,10.5,5.2,1.4,12.6,1.7,12.6,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.87,292.18s1.8,3.9,16.3,3.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.77,302.78s5-3.4,14.5-3.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M215.47,338.08s1.1-13.2,0-25.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M207.27,336.18s6.1.6,7.6-1.3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Lines_Normal",
    "data-name": "Lines Normal"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M184.97,244.28s2.2-13.3,3.9-16.1,7.4-6.7,7.4-6.7l-5.7-1.6s1.9-3.8,4.9-5.4,12.5-3.8,12.5-3.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M172.97,238.68c-2.2-3.5-1-8.9-1-8.9-3.3-3.9-4.9-9.9-4.5-15.1,1-10.8,12.4-24.5,12.4-24.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M198.17,161.98c-12.1,4.2-18.4,19.2-18.4,28.1s6.5,12.3,13.1,16c4,2.3,26.6,4.4,26.6,4.4l-5.4-7.2,9.1,2.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M194.47,181.68s-2.7-7.2,1.1-14.6,16.9-15.7,19.2-22.4c0,0,3.9,7.5,3.2,17.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M226.37,207.08s-11.6-6-13.6-14.7-2.3-19.6,5.2-30.4,15.2-13.1,28.2-14.6c7.8-.9,17.4,2.4,28.7-7.2,0,0,0,7.4-5.1,11.4,0,0,9.7-1.4,14.2-4.7s10.2-7.8,10.2-7.8c0,0,5.4,16.1-7.8,28.9s-32,15.2-39.3,21.3-6.2,15.2-6.2,15.2c0,0-3.1,5.3-14.5,2.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296.27,144.78s6.7,7.5,6.2,15.8-7.2,14.7-7.2,14.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M241.57,204.88s5.3,2.1,9.8.7,18.8-10.8,18.8-10.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M284.47,203.38s-12.6,6-18.1,5.6-13.1-3.8-13.1-3.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M302.77,161.28s3.6,5.6,7.2,9,9.7,8.1,1.6,25.9c-7.1,15.9-21.4,14.5-32.8,17.2-7.4,1.8-9.9-2.9-9.9-2.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M316.17,178.88s4.6.9,5.7,4.5,1.4,25.6-6.3,33.2c-7.7,7.6-15.7,11-22.2,8.4-1.9-.8-.4-4.6-.5-5.9s-10.2-1-12.1-4.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M322.37,200.98c1.3,2.4,0,8.9.9,12.9s3.7,4.4,2.4,11-8.1,13.6-8.1,13.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M298.67,225.88s-1.9,1.2-.1,5.8,3.8,4.5,4.2,11.2,0,10.5,0,10.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M226.77,166.38s-7.8,9.1-8.7,15.8-1.6,15.5,5.2,22.7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Lines_Hands",
    "data-name": "Lines Hands"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M424.07,46.58c.6-4.6.2-12,.8-14.7,1.2-5.4-5.5-24.5-6.8-27.3s-4-3-6.4,0-.2,14.6.6,22c.8,7.4-2,20.4-2.5,24.1s-2.2,19.1-2.2,19.1c0,0-4.3,3.7-5.5,3.8s-11.7-9.7-12.6-10.3-5.9-9.8-11.9-10.5-8.9,6.9-8.9,6.9c8.2,6.7,12.5,12.4,13.5,17s14.9,23.7,17,26.3,13,8,13,8c0,0,11.2,5.6,9.9,14.9-1.3,9.4-3.1,28.8-5.7,44.2-2.6,15.4-9.2,22.3-9,50.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M459.77,62.68s-1-13.6,1.5-25.7c0,0-3.5-18.1-2.4-26.3,1.3-2.1-4.9-7.8-9-2.4-3.3,4.3-1.9,19.2-3.2,23.9-1.3,4.7-3,20.1-5.7,22.3s-2.5-1.5-2.5-1.5c0,0,1.9-17.6,3.1-22.8s-.5-17.2.5-24-7.4-4.9-8.6-2.3-4.8,12.1-4.6,21.6c.2,9.5-6.9,27.3-6.9,27.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M458.27,63.88s6.4-.8,8-5.1,9.1-13.1,10.3-17,1.9-18.1,7.8-18.5,4.4.6,4.4.6c0,0-.4,13.7-1.5,18.3s-9,24.2-9.3,27.9c0,0-8.6,22.9-10.7,34.8s-4.1,17.5-4.1,17.5v115.4s-13.1,11.9-16.2,19.6-48.1,80.5-50.7,89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M407.57,217.28c-.6,8.8-52.5,74-52.5,74,0,0-1.4,18,7.9,28.8s28.7,26.4,35.9,27.8,6.5.6,7.3-.5-5.1-10.7-5.1-10.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M357.07,286.68s-3.1-1.7-4.8,0-26.3,30.8-30.2,33.5-34.1,13-39.7,14.8c1.9.1-3,28.5-37.2,30.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M406.17,347.38s-16.3,20.2-17.3,23.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.37,46.58c-.6-4.6-.2-12-.8-14.7-1.2-5.4,5.5-24.5,6.8-27.3s4-3,6.4,0,.2,14.6-.6,22c-.8,7.4,2,20.4,2.5,24.1s2.2,19.1,2.2,19.1c0,0,4.3,3.7,5.5,3.8s11.7-9.7,12.6-10.3,5.9-9.8,11.9-10.5,8.9,6.9,8.9,6.9c-8.2,6.7-12.5,12.4-13.5,17s-14.9,23.7-17,26.3-13.1,8-13.1,8c0,0-11.2,5.6-9.9,14.9,1.3,9.4,3.1,28.8,5.7,44.2s9.2,22.3,9,50.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.57,62.68s1-13.6-1.5-25.7c0,0,3.6-18.1,2.4-26.3-1.3-2.1,4.9-7.8,9-2.4,3.3,4.3,1.9,19.2,3.2,23.9,1.3,4.7,3,20.1,5.7,22.3s2.5-1.5,2.5-1.5c0,0-1.9-17.6-3.1-22.8s.5-17.2-.5-24,7.4-4.9,8.6-2.3,4.8,12.1,4.6,21.6c-.2,9.5,6.9,27.3,6.9,27.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.17,63.88s-6.4-.8-8-5.1-9.1-13.1-10.3-17-1.9-18.1-7.8-18.5-4.4.6-4.4.6c0,0,.4,13.7,1.5,18.3s9,24.2,9.3,27.9c0,0,8.6,22.9,10.7,34.8s4.1,17.5,4.1,17.5v115.4s13.2,11.9,16.2,19.6,48.1,80.5,50.7,89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.87,217.28c.6,8.8,52.5,74,52.5,74,0,0,1.4,18-7.9,28.8s-28.7,26.4-35.9,27.8-6.5.6-7.3-.5,5.1-10.7,5.1-10.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M133.37,286.68s3.1-1.7,4.8,0,26.3,30.8,30.2,33.5,34.1,13,39.7,14.8c-1.9.1,3.1,28.5,37.2,30.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M84.27,347.38s16.3,20.2,17.3,23.9"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJeffreyjump2);
export default __webpack_public_path__ + "static/media/jeffreyjump2.e0711ba1bbf3acaa1bea98da375db3cf.svg";
export { ForwardRef as ReactComponent };